import React from "react";
import { ExternalLink } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { STATUSES, CATEGORIES } from "./useLeadDetail";

export default function LeadDetailsCard({ lead, user, salespeople, onUpdate }) {
  const isPrivileged = user?.role === "admin" || user?.role === "leader" || user?.role === "super_admin";

  return (
    <div className="bento-card">
      <h2 className="text-lg font-medium text-[#1C1917] mb-4" style={{ fontFamily: "Playfair Display, serif" }}>
        Lead Details
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-[#57534E] mb-1 uppercase tracking-wider">Status</label>
          <Select value={lead.status} onValueChange={(v) => onUpdate("status", v)}>
            <SelectTrigger data-testid="lead-status-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              {STATUSES.map((s) => (<SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>))}
            </SelectContent>
          </Select>
        </div>

        <div>
          <label className="block text-xs font-medium text-[#57534E] mb-1 uppercase tracking-wider">Category</label>
          <Select value={lead.category || "none"} onValueChange={(v) => onUpdate("category", v === "none" ? null : v)}>
            <SelectTrigger data-testid="lead-category-select"><SelectValue placeholder="Select category" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">Select category</SelectItem>
              {CATEGORIES.map((c) => (<SelectItem key={c} value={c}>{c}</SelectItem>))}
            </SelectContent>
          </Select>
        </div>

        {isPrivileged && (
          <div>
            <label className="block text-xs font-medium text-[#57534E] mb-1 uppercase tracking-wider">Assigned To</label>
            <Select value={lead.assigned_to || "unassigned"} onValueChange={(v) => onUpdate("assigned_to", v === "unassigned" ? null : v)}>
              <SelectTrigger data-testid="lead-assigned-select"><SelectValue placeholder="Unassigned" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="unassigned">Unassigned</SelectItem>
                {salespeople.map((sp) => (<SelectItem key={sp.id} value={sp.id}>{sp.name}</SelectItem>))}
              </SelectContent>
            </Select>
          </div>
        )}

        <div>
          <label className="block text-xs font-medium text-[#57534E] mb-1 uppercase tracking-wider">Source</label>
          <p className="form-input bg-[#F5F2EA] capitalize">
            {lead.source === "wati" ? "WhatsApp (WATI)" : lead.source}
          </p>
        </div>
      </div>

      <div className="mt-4">
        <label className="block text-xs font-medium text-[#57534E] mb-1 uppercase tracking-wider">Notes</label>
        <textarea
          value={lead.notes || ""}
          onChange={(e) => onUpdate("notes", e.target.value)}
          className="form-input min-h-[80px]"
          placeholder="Add internal notes..."
          data-testid="lead-notes"
        />
      </div>

      {lead.source_url && (
        <div className="mt-4">
          <label className="block text-xs font-medium text-[#57534E] mb-1 uppercase tracking-wider">Source URL</label>
          <a href={lead.source_url} target="_blank" rel="noopener noreferrer" className="text-[#BC4B35] hover:underline text-sm flex items-center gap-1">
            <ExternalLink size={14} /> {lead.source_url}
          </a>
        </div>
      )}
    </div>
  );
}
